import { useDispatch } from "react-redux"
import { tasksActions } from "../../store/tasks"
import Button from "../common/Button"

export default function TasksRefreshApi() {
    const dispatch = useDispatch()

    async function refreshApihandler() {     
        dispatch(tasksActions.setRefreshApi())
    }
    return <Button title={'refresh api'} click={refreshApihandler}><i className='ti ti-refresh'></i></Button>
}